import React, {Component} from 'react';
import {Link} from 'react-router';
import R from 'ramda';

import Cards from './cards';
import Footer from 'js/components/footer';

export default class Jobs extends Component {
    static list = [
        {
            image: require('images/icons/laptop.png'),
            header: 'VP Of Engineering',
            body: 'As VP of Engineering, you will focus on the recruitment, retainment, and management of the Engineering department. You will have a hand in architecture, design, and implementation as you thoughtfully lead of team of highly skilled engineering in Los Angeles and remote.',
            postBody: <div><Link to="/jobs/vp_of_engineering">Read More</Link></div>
        },
        {
            image: require('images/icons/calculator.png'),
            header: 'Director of Finance',
            body: 'As Director of Finance, you will manage the company\'s general accounting activities to ensure timely and accurate delivery of financial information.',
            postBody: <div><Link to="/jobs/director_of_finance">Read More</Link></div>
        },
        {
            image: require('images/icons/users.png'),
            header: 'Recruiting Manager',
            body: 'You will bring in top talent, streamline our recruiting process, and implement HR and recruiting groundwork.',
            postBody: <div><Link to="/jobs/recruiting_manager">Read More</Link></div>
        },
        {
            image: require('images/icons/bar_chart.png'),
            header: 'Senior Full Stack Engineer',
            body: 'As a Senior Fullstack Engineer, you will contribute to the front-end and back-end of the platform. You are a javascript expert and know how to ship. An ideal candidate would be comfortable building web applications, APIs, and working with relational databases.',
            postBody: <div><Link to="/jobs/full_stack_engineer">Read More</Link></div>
        },
        {
            image: require('images/icons/bar_chart.png'),
            header: 'Senior Data Engineer',
            body: "As a Senior Data Engineer, you'll be in charge of furthering the company’s data platform and related infrastructure. To perform this job, you will need to be an expert with relational databases, NoSQL databases, and distributed computing. You are comfortable creating systems that ingest and analyze data at scale.",
            postBody: <div><Link to="/jobs/data_engineer">Read More</Link></div>
        },
        {
            image: require('images/icons/paper_airplane.png'),
            header: 'Recruiting / Talent Sourcer',
            body: 'As a talent sourcer, you will build our pipeline for a number of positions across business and technicals roles. You are creative and proactive in your approach for identifying top level talent.',
            postBody: <div><Link to="/jobs/talent_sourcer">Read More</Link></div>
        },
        {
            image: require('images/icons/megaphone.png'),
            header: 'Sales Director',
            body: 'We are seeking a Sales Director to acquire strategic accounts, assist in growing a start-up from nearly the ground floor, and showcase passion throughout that journey.',
            postBody: <div><Link to="/jobs/sales_director">Read More</Link></div>
        },
        {
            image: require('images/icons/archive.png'),
            header: 'Account Manager',
            body: 'You will manage some of our most strategic clients and work with our GM to buid out the departmental operations to create an awesome client experience.',
            postBody: <div><Link to="/jobs/account_manager">Read More</Link></div>
        }
    ];


    render() {
        return (
            <div id="jobs">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="hide show@sm">
                        <Link to="/content_creator">CONTENT CREATORS</Link>
                        <Link to="/faq">FAQ</Link>
                        <Link className="active" to="/jobs">JOIN US</Link>
                    </div>
                    <div className="header-title">
                        <h1>Join Our Team</h1>
                        <p>
                            Social Native was founded by veterans of Google, Scopely, Applied Semantics, and Salesforce whose past startups have created over $6B in equity value. We are building another industry transforming company,
                            working with the world’s largest brands to create uniquely engaging content.
                        </p>
                        <br />
                        <p>
                            We are growing our family and are looking at you. If you think you have what it takes have a
                            look at what we have to offer and&nbsp;
                            <a href="mailto:info@socialnative.com">contact us!</a>
                        </p>
                    </div>
                </header>
                <main className="container">
                    <Cards jobList={Jobs.list} />
                </main>
                <Footer dontShowJobs={true}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs/index.js